import { Navigate, RouteObject } from 'react-router-dom'

import { ChatPage } from './pages/ChatPage'
import { ChatRoomPage } from './pages/ChatRoomPage'
import { ChatSettingsPage } from './pages/ChatSettingsPage'
import { ChatAnalyticsPage } from './pages/ChatAnalyticsPage'
import { BannedChatsPage } from './pages/BannedChatsPage'
import { ClosedChatsPage } from './pages/ClosedChatsPage'
import { BroadcastPage } from './pages/BroadcastPage'
import {
	GreetingSettingsPage,
	AutoReplySettingsPage,
	TagsSettingsPage,
	QuickResponsesSettingsPage,
	ChatSettingsAiTab,
} from './pages/ChatSettingsPage/components'

export const chatRoutes: RouteObject[] = [
	{
		path: 'chat',
		element: <ChatPage />,
		children: [
			{
				path: ':roomId',
				element: <ChatRoomPage />,
			},
		],
	},
	{
		path: 'chat/settings',
		element: <ChatSettingsPage />,
		children: [
			{
				index: true,
				element: <Navigate to="greeting" replace />,
			},
			{
				path: 'greeting',
				element: <GreetingSettingsPage />,
			},
			{
				path: 'auto-reply',
				element: <AutoReplySettingsPage />,
			},
			{
				path: 'tags',
				element: <TagsSettingsPage />,
			},
			{
				path: 'quick-responses',
				element: <QuickResponsesSettingsPage />,
			},
			{
				path: 'ai',
				element: <ChatSettingsAiTab />,
			},
		],
	},
	{
		path: 'chat/analytics',
		element: <ChatAnalyticsPage />,
	},
	{
		path: 'chat/banned',
		element: <BannedChatsPage />,
	},
	{
		path: 'chat/closed',
		element: <ClosedChatsPage />,
	},
	{
		path: 'chat/broadcast',
		element: <BroadcastPage />,
	},
]
